module.exports = __webpack_public_path__ + "static/img/sysch5.c9f09bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sysch5.png
// module id = 6CKZ
// module chunks = 0